import { AfterViewInit, Component, OnDestroy, OnInit, inject, viewChild } from '@angular/core';
import { faPen, faTrash } from '@fortawesome/pro-light-svg-icons';
import { faHandHoldingUsd } from '@fortawesome/pro-solid-svg-icons';
import { SubSink } from 'subsink';
import { UserOperation } from '../../../core/enums/user-operation';
import { ProjectExpenseModel } from '../../../core/models/finance/expense.model';
import { ShiveRoutes } from '../../../core/routing/segments/route-segments';
import { ShiveGridWrapperComponent } from '../../../shared/components/shive-controls/shive-grid/shive-grid-wrapper.component';
import { OperatingCostsGridService } from './operating-costs-grid.service';

@Component({
  selector: 'app-operating-costs',
  templateUrl: './operating-costs.component.html',
  standalone: false,
})
export class OperatingCostsComponent implements OnInit, AfterViewInit, OnDestroy {
  gridWrapperComponent = viewChild<ShiveGridWrapperComponent>('gridWrapperComponent');

  // Constants
  public readonly ShiveRoutes = ShiveRoutes;
  public readonly UserOperation = UserOperation;
  public readonly faHandHoldingUsd = faHandHoldingUsd;

  // Getter / Setter
  public get gridData(): ProjectExpenseModel[] {
    return this.operatingCostsGridService.gridData();
  }

  // DI
  private readonly operatingCostsGridService = inject(OperatingCostsGridService);

  // Misc
  private readonly subs = new SubSink();

  ngOnInit(): void {
    this.operatingCostsGridService.fetchProjectExpenses();
  }

  ngAfterViewInit(): void {
    this.initContextMenuCallbacks();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  public openCostsDialog(operation: UserOperation): void {
    this.operatingCostsGridService.openExpenseDialog(operation);
  }

  private initContextMenuCallbacks(): void {
    this.gridWrapperComponent().contextMenuItems = [
      {
        text: 'Bearbeiten',
        faIcon: faPen,
        callback: (projectExpenseRow: ProjectExpenseModel) =>
          this.operatingCostsGridService.openExpenseDialog(UserOperation.Update, projectExpenseRow),
        isVisible: true,
        isActivated: true,
      },
      {
        text: 'Löschen',
        faIcon: faTrash,
        callback: (projectExpenseRow: ProjectExpenseModel) => {
          this.operatingCostsGridService.deleteExpenseRow(projectExpenseRow);
        },
        isVisible: true,
        isActivated: true,
        iconColorClass: 'red',
      },
    ];
  }
}
